/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerListByRootFileIdQueryResponse, ComparisonsControllerListByRootFileIdQueryParams, ComparisonsControllerListByRootFileId401, ComparisonsControllerListByRootFileId403 } from "../../models/comparisonsController/ComparisonsControllerListByRootFileId";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { comparisonsControllerListByRootFileId } from "../../clients/comparisonsService/comparisonsControllerListByRootFileId";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const comparisonsControllerListByRootFileIdQueryKey = (params: ComparisonsControllerListByRootFileIdQueryParams) => [{
  url: '/api/v1/comparisons'
}, ...(params ? [params] : [])] as const;
export type ComparisonsControllerListByRootFileIdQueryKey = ReturnType<typeof comparisonsControllerListByRootFileIdQueryKey>;
export function comparisonsControllerListByRootFileIdQueryOptions(params: ComparisonsControllerListByRootFileIdQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = comparisonsControllerListByRootFileIdQueryKey(params);
  return queryOptions<ComparisonsControllerListByRootFileIdQueryResponse, ResponseErrorConfig<ComparisonsControllerListByRootFileId401 | ComparisonsControllerListByRootFileId403>, ComparisonsControllerListByRootFileIdQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return comparisonsControllerListByRootFileId(params, config);
    }
  });
}

/**
 * @description Returns comparisons for rootFileId, one per (scopeIdA, scopeIdB) when multiple runs exist (newest kept), ordered by createdAt descending.
 * @summary List comparisons by root file
 * {@link /api/v1/comparisons}
 */
export function useComparisonsControllerListByRootFileId<TData = ComparisonsControllerListByRootFileIdQueryResponse, TQueryData = ComparisonsControllerListByRootFileIdQueryResponse, TQueryKey extends QueryKey = ComparisonsControllerListByRootFileIdQueryKey>(params: ComparisonsControllerListByRootFileIdQueryParams, options: {
  query?: Partial<QueryObserverOptions<ComparisonsControllerListByRootFileIdQueryResponse, ResponseErrorConfig<ComparisonsControllerListByRootFileId401 | ComparisonsControllerListByRootFileId403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? comparisonsControllerListByRootFileIdQueryKey(params);
  const query = useQuery({
    ...comparisonsControllerListByRootFileIdQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ComparisonsControllerListByRootFileId401 | ComparisonsControllerListByRootFileId403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}